module.exports = __webpack_public_path__ + "img/flowers_in_a_vase.3a0ed50a.jpg";